// Single source of truth for the collaborator's active company id, persisted
// per-device in localStorage. Read by the API client (to send the
// X-Active-Company header) and by ActiveCompanyContext. A null/invalid value
// means "no explicit choice" → the backend falls back to the primary company.
export const ACTIVE_COMPANY_KEY = 'active_company_id';

export function getActiveCompanyId(): number | null {
  const raw = window.localStorage.getItem(ACTIVE_COMPANY_KEY);
  if (raw === null) return null;
  const parsed = Number(raw);
  return Number.isInteger(parsed) ? parsed : null;
}

export function setActiveCompanyId(id: number | null): void {
  if (id === null) {
    window.localStorage.removeItem(ACTIVE_COMPANY_KEY);
    return;
  }
  window.localStorage.setItem(ACTIVE_COMPANY_KEY, String(id));
}
